import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getApiBaseUrl } from 'modules/api/utils';

import type { PostNatalieFeedbackPayload, PostNatalieFeedbackResponse } from './types';

export const natalieFeedbackApi = createApi({
  reducerPath: 'natalieFeedbackApi',
  baseQuery: axiosBaseQuery({ baseURL: getApiBaseUrl('v1') }),
  endpoints: (builder) => ({
    postFeedback: builder.mutation<PostNatalieFeedbackResponse, PostNatalieFeedbackPayload>({
      query: (data) => ({
        url: '/feedback/natalie',
        method: 'POST',
        data,
      }),
    }),
  }),
});
